/**
 * Le signal « la session est finie », du client de l'API vers l'interface.
 *
 * Le client (`SessionAwareClient`) vit hors React : quand une requête reste refusée par la
 * passerelle APRÈS renouvellement des identifiants, il n'a ni `navigate`, ni snackbar, ni
 * `signOut` à portée. Il appelle `notifySessionExpired()` ; `useSessionExpiry`, monté sous
 * le routeur, s'y abonne et fait le reste (message, déconnexion, retour à `/signin`).
 *
 * Pas le `Hub` d'Amplify : son canal `auth` est protégé (`Hub.dispatch` y est refusé), et
 * un canal maison n'apporterait rien de plus qu'un `Set` d'abonnés.
 */
type SessionExpiredListener = () => void;

const listeners = new Set<SessionExpiredListener>();

/** Prévient les abonnés. Plusieurs requêtes qui tombent en rafale appellent ceci plusieurs fois : c'est à l'abonné de ne réagir qu'une fois. */
export function notifySessionExpired(): void {
  for (const listener of listeners) {
    listener();
  }
}

/** S'abonne ; rend la fonction de désabonnement, à retourner depuis un `useEffect`. */
export function onSessionExpired(listener: SessionExpiredListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
